/**
 * NAP API
 * REST-Api für das nap Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@conergos.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ActivityDto } from '@bo-client/shared/models/activityDto';
import { ConnectionObject } from '@bo-client/shared/models/connectionObject';
import { ContactData } from '@bo-client/shared/models/contactData';
import { OrderDto } from '@bo-client/shared/models/orderDto';
import { UserDto } from '@bo-client/shared/models/userDto';
import AreaEnum = OrderDto.AreaEnum;
import { RequestModel } from '@bo-client/shared/models/request.model';

interface MwstInfo {
  percentage: number;
  amount: number;
}

export interface OrderRequestDto {
  coreDrilling?: boolean;
  cornerPlot?: boolean;
  reachableViaPrivateRoad?: boolean;
  floorArea?: number;
  developmentType?: 'inclusive' | 'exclusive';
  streetConnectionDiscount?: boolean;
  mwstGrouped?: MwstInfo[];
  customerComment?: string;
  modifiedBy?: string;
  inDevelopmentArea?: boolean;
  areaOrders?: Array<OrderDto>;
  areas?: Array<OrderRequestDto.AreasEnum>;
  actionCode?: string;
  connectionLength?: number;
  connectionLengthPrivate?: number;
  connectionObject?: ConnectionObject;
  id?: number;
  invoiceAddress?: ContactData;
  invoiceShipping?: string;
  prices?: { [key: string]: number };
  sapcoreDebitorId?: string;
  usesCompanyTaxation?: boolean;
  taxRate?: number;
  tiefbau?: OrderRequestDto.TiefbauEnum;
  isInvolved?: 'YES' | 'NO' | 'UNKNOWN';
  involvedParty?: string;
  isEasement?: string;
  buildingDevelopment?: string;
  totalPriceBrutto?: number;
  additionalText?: string;
  totalPriceNetto?: number;
  useGas?: boolean;
  useLwl?: boolean;
  usePower?: boolean;
  user?: UserDto;
  isOwner?: boolean;
  supplyDate?: string;
  executionDate?: string;
  stateModifiedDate?: string | Date;
  comment?: string;
  uploads?: any;
  activities?: ActivityDto[];
  canOrderAutomatically?: boolean;
  state?: OrderStateEnum;
  coreDebitorId?: string;
  isuDebitorId?: string;
  isNewBuilding?: boolean;
  positions?: OfferPosition[];
  internalPositions?: OfferPosition[];
  breakupAnnouncementCreated?: boolean;
  inspectionAppointment?: string;
  inspectionAppointmentComment?: string;
  serviceProviderDocumentsAttached?: boolean;
  completenessCheckSuccessfull?: boolean;
  completenessCheckBy?: string;
  completenessCheckDateTime?: any;
  executingCivilEngineeringPartner?: any;
  responsibleBuildingAuthority?: any;
  lbm?: any;
  createdDate?: string | Date;
  modifiedDate?: string | Date;
  priceDate?: string | Date;
  lastModifiedBy?: string;
  shortDescription?: string;

  buildingType?: any;
  businessType?: any;
  electricalPower?: any;
  livingUnits?: any;
  usableCommercialSpace?: any;
  livingSpace?: any;

  buildingHasCellar?: string;
  hasAsphaltFoundation?: string;
  multiDivisionBuildingEntryRequested?: boolean;
  multiDivisionBuildingEntryShipping?: string;
  waterMeterColumnRequested?: boolean;
  buildingPowerSupplyRequested?: boolean;
  buildingWaterSupplyRequested?: boolean;
  frontLengthPlot?: any;
  connectionBoxType?: string;
  connectionPointType?: ConnectionPointTypeEnum;
  meterCabinetType?: MeterCabinetTypeEnum;

  useCustomPricing?: boolean;
  billingType?: BillingTypeEnum;
  telecommunicationRequested?: boolean;
  telecommunicationProvider?: string;
  projectManagerMail?: string;
  projectManagerPhone?: string;
  projectManagerName?: string;

  connectionLengthPaved?: number;
  connectionLengthUnPaved?: number;
  approved?: boolean;
  approverEmail?: string;
  approvedBy?: string;
  approvedDateTime?: string | Date;
  /** Sachbearbeiter, der die Freigabe angefordert hat — Empfänger der Benachrichtigung. */
  approvalRequestedBy?: string;
  approvalRequestedDateTime?: string | Date;
  pmId?: string;
  internalPricing?: any;

  extinguishingDeviceCount?: number;
  fuseReinforcementCount?: number;
}

/** Art des Netzverknüpfungspunkts (Leer / Ab Ortsnetz / Ab Station) */
export type ConnectionPointTypeEnum = 'EMPTY' | 'FROM_LOW_VOLTAGE' | 'FROM_STATION';

/** SVK-Messschrank (2-tlg. / 3-tlg.) */
export type MeterCabinetTypeEnum = 'TWO_PART' | 'THREE_PART';

/** Abrechnungsart des Hausanschlussauftrags — führendes Merkmal für die ILA/IHLA in SAP */
export type BillingTypeEnum = 'FLAT_RATE' | 'FLAT_RATE_CALCULATED' | 'BY_EFFORT';

export class OrderRequestModel extends RequestModel implements OrderRequestDto {
  state: OrderStateEnum;
  coreDrilling?: boolean;
  cornerPlot?: boolean;
  reachableViaPrivateRoad?: boolean;
  floorArea?: number;
  developmentType?: 'inclusive' | 'exclusive';
  streetConnectionDiscount?: boolean;
  mwstGrouped?: MwstInfo[];
  customerComment?: string;
  modifiedBy?: string;
  inDevelopmentArea?: boolean;
  areaOrders?: OrderDto[];
  areas?: OrderRequestDto.AreasEnum[];
  actionCode?: string;
  connectionLength?: number;
  connectionLengthPrivate?: number;
  connectionObject?: ConnectionObject;
  invoiceAddress?: ContactData;
  invoiceShipping?: string;
  prices?: { [key: string]: number };
  sapcoreDebitorId?: string;
  usesCompanyTaxation?: boolean;
  taxRate?: number;
  tiefbau?: OrderRequestDto.TiefbauEnum;
  buildingDevelopment?: string;
  totalPriceBrutto?: number;
  additionalText?: string;
  totalPriceNetto?: number;
  useGas?: boolean;
  useLwl?: boolean;
  usePower?: boolean;
  user?: UserDto;
  isOwner?: boolean;
  supplyDate?: string;
  executionDate?: string;
  comment?: string;
  uploads?: any;
  activities?: ActivityDto[];
  canOrderAutomatically?: boolean;
  coreDebitorId?: string;
  isuDebitorId?: string;
  isNewBuilding?: boolean;
  positions?: OfferPosition[];
  breakupAnnouncementCreated?: boolean;
  inspectionAppointment?: string;
  inspectionAppointmentComment?: string;
  serviceProviderDocumentsAttached?: boolean;
  completenessCheckSuccessfull?: boolean;
  completenessCheckBy?: string;
  completenessCheckDateTime?: any;
  executingCivilEngineeringPartner?: any;
  responsibleBuildingAuthority?: any;
  lbm?: any;
  priceDate?: string | Date;
  shortDescription?: string;
  buildingType?: any;
  businessType?: any;
  electricalPower?: any;
  livingUnits?: any;
  buildingHasCellar?: string;
  hasAsphaltFoundation?: string;
  multiDivisionBuildingEntryRequested?: boolean;
  multiDivisionBuildingEntryShipping?: string;
  waterMeterColumnRequested?: boolean;
  buildingPowerSupplyRequested?: boolean;
  buildingWaterSupplyRequested?: boolean;
  frontLengthPlot?: any;
  connectionBoxType?: string;
  connectionPointType?: ConnectionPointTypeEnum;
  meterCabinetType?: MeterCabinetTypeEnum;
  useCustomPricing?: boolean;
  billingType?: BillingTypeEnum;
  telecommunicationRequested?: boolean;
  telecommunicationProvider?: string;
  projectManagerMail?: string;
  projectManagerPhone?: string;
  projectManagerName?: string;
  approved?: boolean;
  approverEmail?: string;
  approvedBy?: string;
  approvedDateTime?: string | Date;
  /** Sachbearbeiter, der die Freigabe angefordert hat — Empfänger der Benachrichtigung. */
  approvalRequestedBy?: string;
  approvalRequestedDateTime?: string | Date;
  pmId?: string;
  extinguishingDeviceCount?: number;
  fuseReinforcementCount?: number;
}

export interface OfferPosition {
  filteredOptions?: any[]; // this is not existing in the backend model but is used for the drag and drop
  area?: AreaEnum;
  id: number;
  name: string;
  amount: number;
  unitPrice: number;
  amountFormatted?: string;
  tax: number;
  amountBrutto: number | null;
  externalId: string | null;
  quantity: number | null;
  position: number;
  customAttributes?: unknown;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace OrderRequestDto {
  export type AreasEnum = 'Power' | 'Gas' | 'LWL';
  export const AreasEnum = {
    Power: 'Power' as AreasEnum,
    Gas: 'Gas' as AreasEnum,
    LWL: 'LWL' as AreasEnum
  };
  export type TiefbauEnum = 'YES' | 'NO' | 'PUBLIC_ONLY';
  export const TiefbauEnum = {
    YES: 'YES' as TiefbauEnum,
    NO: 'NO' as TiefbauEnum,
    PUBLICONLY: 'PUBLIC_ONLY' as TiefbauEnum
  };
}

export enum OrderStateEnum {
  Created = 'created',
  Placed = 'placed',
  CreatingSap = 'creating_sap',
  ConfirmationRequestedByMail = 'confirmation_requested_by_mail',
  Confirmed = 'confirmed',
  ErrorCreatingOrder = 'error_creating_order',
  Approved = 'approved',
  UnderConstruction = 'under_construction',
  InProgress = 'in_progress',
  TechnicallyCompleted = 'technically_completed',
  CommerciallyCompleted = 'commercially_completed',
  Canceled = 'canceled'
}
